var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"login page"},[_c('img',{staticClass:"logo",attrs:{"src":"/logo.png","alt":""}}),_c('div',{staticClass:"tips"},[_vm._v("请使用微信授权登录")]),_c('button',{attrs:{"type":"button"},on:{"click":_vm.login}},[_vm._v("微信授权登录")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }